
import {GetCoordinatesQuery} from "../../../types/api/map/map.types";
import {mapService} from "../../../services/map/map-service";


export async function mapDataBySelection(query: GetCoordinatesQuery) {
    const data = await mapService.getCoordinatesGeofenceAndCP(query);

    return data.data;
}

// export async function fetchVehiclesByIds(vehicleIds: string[], allVehicles: any[]): Promise<MapVehicleData[]> {
//     if (!vehicleIds.length) return [];
//     const idSet = new Set(vehicleIds.map((id) => normalizeId(id)).filter(Boolean));
//
//     const baseVehicles = (allVehicles as any[]).filter((v) => idSet.has(normalizeId(v?.id)));
//     const merged = new Map<string, MapVehicleData>();
//
//     baseVehicles
//         .filter((v) => Array.isArray(v?.coords) && v.coords.length === 2)
//         .forEach((v) => {
//             const id = normalizeId(v?.id);
//             const name = String(v?.number ?? v?.name ?? "").trim();
//             const coords = v.coords as [number, number];
//             if (id && name) merged.set(id, { id, name, coords });
//         });
//
//     if (merged.size < idSet.size) {
//         const idToName = new Map<string, string>();
//         baseVehicles.forEach((v) => {
//             const id = normalizeId(v?.id);
//             const name = String(v?.number ?? v?.name ?? "").trim();
//             if (id && name) idToName.set(id, name);
//         });
//
//         const vehicleNames = [...idSet]
//             .map((id) => idToName.get(id))
//             .filter((name): name is string => Boolean(name));
//
//         if (vehicleNames.length) {
//             try {
//                 const response = await mapMonitoringService.getFilteredVehicles({ vehicleNames });
//                 const data = response?.data?.vehicles ?? [];
//                 data
//                     .filter((v: any) => Array.isArray(v?.coords) && v.coords.length === 2)
//                     .forEach((v: any) => {
//                         const id = normalizeId(v?.id);
//                         const name = String(v?.name ?? v?.number ?? "").trim();
//                         const coords = v.coords as [number, number];
//                         if (id && name) merged.set(id, { id, name, coords });
//                     });
//             } catch {
//             }
//         }
//     }
//
//     return [...merged.values()];
// }

